import * as React from 'react';

export default function useDebouncedState<T>(
    initialValue: T | (() => T),
    delay = 250,
): [T, T, React.Dispatch<React.SetStateAction<T>>] {
    const [currentValue, setCurrentValue] = React.useState(initialValue);

    const [debouncedValue, setDebouncedValue] = React.useState(initialValue);
    const [timer, setTimer] = React.useState<NodeJS.Timeout | null>(null);

    React.useEffect(() => {
        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }

        const newTimer = setTimeout(() => {
            setDebouncedValue(currentValue);
        }, delay);

        setTimer(newTimer);

        return () => {
            if (timer) {
                clearTimeout(timer);
                setTimer(null);
            }
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentValue, delay]);

    return [currentValue, debouncedValue, setCurrentValue];
}
